<template>
    <div
        style="position: relative"
        :style="{ height: isSearch ? 'calc(100vh - 171px)' : 'calc(100vh - 145px)' }"
    >
        <div class="top-tool fx-v-center">
            <el-button
                style="width: 100px; height: 36px; padding: 10px 0; margin-right: 10px"
                type="primary"
                size="medium"
                @click="addGoodsWithGroupInfo()"
            >+添加商品</el-button>
            <more-operate>
                <div class="operate-detail-item fx-v-center fx-h-between">
                    <span class="fs-14 mr-37">显示已下架商品</span>
                    <el-switch @change="switchChange" v-model="isShowDownGoods" />
                </div>
                <div
                    class="more-operate-item align-l"
                    @click="$router.push('/main/goodsLibrary/goodsImport')"
                >批量导入商品</div>
            </more-operate>
            <search @searchData="searchGoods" :styleData="searchStyle"></search>
        </div>
        <p class="color-333 fs-14 mt-12" v-if="isSearch">
            以下为搜索
            <span class="color-green">{{ keyword }}</span> 的商品
        </p>
        <div class="goods-list-container">
            <div class="left-grouop" v-loading="isGroupLoading">
                <ul>
                    <li class="gourp">
                        <div
                            class="level-item level-1"
                            :class="{'level-active': currentActiveGroup.level1 === 0}"
                            @click="activeLevel({id: 0}, {id: 0})"
                        >
                            <span class="gourp-name">所有商品</span>
                            <group-popper
                                class="group-popper"
                                @addGoods="addGoodsWithGroupInfo()"
                                @groupChange="groupChange($event, false)"
                                :group="{id: 0}"
                                :allGroup="goodsGroup"
                                :level="1"
                            ></group-popper>
                            <span class="goods-count">{{allGoodsCount}}</span>
                        </div>
                    </li>
                </ul>
                <draggable
                    tag="ul"
                    v-model="goodsGroup"
                    draggable=".level1-drag-item"
                    :animation="150"
                    easing="cubic-bezier(1, 0, 0, 1)"
                    @end="onLevel1DragEnd"
                >
                    <Drop
                        tag="li"
                        @dragenter="(goodsInfo, evt) => {level1Dragenter(goodsInfo, evt, level1)}"
                        @dragover="onDragEnter"
                        @dragleave="onDragLeave"
                        class="gourp level1-drag-item"
                        v-for="level1 in goodsGroup"
                        :data-level1-id="level1.id"
                        :key="level1.id"
                    >
                        <Drop
                            tag="div"
                            @drop="onGoodsDragEnd"
                            class="level-item level-1"
                            :class="{'level-active': currentActiveGroup.level1 === level1.id && currentActiveGroup.level2 === 0}"
                            :data-level1-id="level1.id"
                            @click.native="activeLevel(level1, {id: 0})"
                        >
                            <i
                                class="iconfont iconright"
                                :class="[{'is-rotate': level1.isExpand}]"
                                v-if="level1.secondary_group.length > 0"
                            ></i>
                            <span class="gourp-name">{{level1.name}}</span>
                            <group-popper
                                class="group-popper"
                                @addGoods="addGoodsWithGroupInfo"
                                @groupChange="groupChange($event, level1.id === currentActiveGroup.level1)"
                                :group="level1"
                                :groupId="level1.id"
                                :allGroup="goodsGroup"
                                :level="1"
                            ></group-popper>
                            <span class="goods-count">{{level1.goods_num}}</span>
                        </Drop>
                        <draggable
                            v-model="level1.secondary_group"
                            :move="onLevel2Move"
                            tag="ul"
                            draggable=".level2-drag-item"
                            class="level-2-group"
                            :animation="150"
                            easing="cubic-bezier(1, 0, 0, 1)"
                            v-if="level1.secondary_group.length > 0 && level1.isExpand"
                            @end="onLevel2DragEnd"
                        >
                            <Drop
                                tag="li"
                                @drop="onGoodsDragEnd"
                                @dragover="onDragEnter"
                                @dragleave="onDragLeave"
                                class="level-item level-2 level2-drag-item"
                                :class="{'level-active': currentActiveGroup.level1 === level1.id && currentActiveGroup.level2 === level2.id}"
                                @click.native="activeLevel(level1, level2)"
                                v-for="level2 in level1.secondary_group"
                                :key="level2.id"
                                :data-level1-id="level1.id"
                                :data-level2-id="level2.id"
                            >
                                <span class="gourp-name">{{level2.name}}</span>
                                <group-popper
                                    class="group-popper"
                                    @addGoods="addGoodsWithGroupInfo"
                                    @groupChange="groupChange($event, level2.id === currentActiveGroup.level2)"
                                    :groupId="level1.id"
                                    :secondGroupId="level2.id"
                                    :group="level2"
                                    :allGroup="goodsGroup"
                                    :level="2"
                                ></group-popper>
                                <span class="goods-count">{{level2.goods_num}}</span>
                            </Drop>
                        </draggable>
                    </Drop>
                </draggable>
            </div>
            <drag
                :draggable="selectedGoods.length > 0"
                class="right-list"
                :transfer-data="selectedGoods"
            >
                <el-checkbox-group v-model="selectedGoods" style="height: 100%">
                    <table
                        v-loading="isGoodsListLoading"
                        v-textHighlight="{
                        keyword,
                        indexs: [2],
                        isBegin: !isGoodsListLoading
                    }"
                    >
                        <thead>
                            <tr>
                                <td></td>
                                <td>#</td>
                                <td>商品名</td>
                                <td class="all-group" v-show="currentActiveGroup.level1 === 0">
                                    <table-data-cascader-filter
                                        v-model="cascaderVal"
                                        :props="{ expandTrigger: 'hover' }"
                                        :options="[{ value: 0, label: '所有分组' }].concat(getGroup(goodsGroup)).concat({ value: -1, label: '无分组' })"
                                        @change="filterCascaderChange"
                                    />
                                </td>
                                <td class="t-r">售价</td>
                                <td></td>
                                <td>商品编码</td>
                                <td>商品类目</td>
                                <td>操作</td>
                                <!-- <td></td> -->
                            </tr>
                        </thead>
                        <tbody class="goods-tbody" ref="tbody">
                            <!-- <draggable class="goods-tbody" v-model="goodsList" ref="tbody" tag="tbody" draggable=".goods-drag-item" :animation="150" easing="cubic-bezier(1, 0, 0, 1)" :move="onGoodsMove" @end="onGoodsDragEnd"> -->
                            <tr
                                tag="tr"
                                :draggable="selectedGoods.length > 0 && selectedGoods.includes(goods.id)"
                                class="goods-drag-item"
                                :class="{ 'is-down': goods.status === 1 }"
                                v-for="(goods, index) in goodsList"
                                :key="goods.id"
                                :data-goods-id="goods.id"
                            >
                                <td>
                                    <el-checkbox :label="goods.id"></el-checkbox>
                                </td>
                                <td>{{index + 1}}</td>
                                <!-- 商品名 -->
                                <td>
                                    <span class="text-popper" v-copyText v-textPopper>{{goods.name}}</span>
                                </td>
                                <!-- 所有分组 -->
                                <td class="all-group" v-show="currentActiveGroup.level1 === 0">
                                    <span
                                        class="text-popper"
                                        v-copyText
                                        v-textPopper
                                    >{{getGoodsGroupName(goods)}}</span>
                                </td>
                                <!-- 售价 -->
                                <td class="t-r">
                                    <div v-copyText class="fx-v-center fx-h-end">
                                        <span
                                            v-textPopper
                                            class="text-popper"
                                            :style="{
                                            width: 'auto',
                                            maxWidth: 'calc(100% - 24px)'
                                        }"
                                        >{{ get(goods.pricing_methods[0], 'sale_prices[0].sale_price') }}元/{{ get(goods.pricing_methods[0], 'sale_prices[0].sale_unit.name') }}</span>
                                        <el-tooltip
                                            v-if="get(goods.pricing_methods[0], 'sale_prices.length') > 1"
                                            effect="dark"
                                            placement="top"
                                        >
                                            <img
                                                class="ml-4"
                                                style="width: 19px"
                                                src="./images/ladder-price.svg"
                                                alt
                                            />
                                            <div
                                                class="alogn-l color-fff fs-12 lh-18 pr-20"
                                                slot="content"
                                            >
                                                <p class="align-c mb-6">阶梯价</p>
                                                <p
                                                    class="mb-2"
                                                >起售价 (购买量>=0)：{{ get(goods.pricing_methods[0], 'sale_prices[0].sale_price') }}元/{{ get(goods.pricing_methods[0], 'sale_prices[0].sale_unit.name') }}</p>
                                                <p
                                                    v-for="(item) in (get(goods.pricing_methods[0], 'sale_prices').slice(1) || [])"
                                                    class="mb-2"
                                                    :key="item.id"
                                                >购买量>={{ item.threshold }}{{ get(item, 'sale_unit.name') }}：{{ item.sale_price }}元/{{ get(item, 'sale_unit.name') }}</p>
                                            </div>
                                        </el-tooltip>
                                    </div>
                                </td>
                                <td></td>
                                <!-- 商品编码 -->
                                <td>
                                    <span
                                        v-copyText
                                        class="text-popper"
                                        v-textPopper
                                    >{{ goods.goods_code || '-' }}</span>
                                </td>

                                <!-- 商品类目 -->
                                <td>
                                    <span
                                        v-copyText
                                        class="text-popper"
                                        v-textPopper
                                    >{{ (goods.category && goods.category.name) || '-' }}</span>
                                </td>

                                <!-- 操作 -->
                                <td>
                                    <button class="pl-0 text-btn" @click="showDetail(goods)">详情</button>
                                    <button class="text-btn" @click="editDetail(goods)">编辑</button>
                                </td>
                            </tr>
                            <tr class="bottom">
                                <td class="align-c color-999">
                                    <span
                                        class="loading-step-animation"
                                        v-if="isHasMore && isLoading"
                                    >正在加载...</span>
                                    <span v-if="(!isHasMore) && goodsList.length > 0">没有更多了</span>
                                </td>
                            </tr>
                        </tbody>
                        <!-- </draggable> -->

                        <tfoot>
                            <tr v-loading="isOnSubmit">
                                <td>
                                    <template v-if="selectedGoods.length > 0">
                                        <el-button size="medium" plain @click="setGoodsStatus(0)">上架</el-button>
                                        <el-button size="medium" plain @click="setGoodsStatus(1)">下架</el-button>
                                        <el-button
                                            type="danger"
                                            size="medium"
                                            plain
                                            @click="setGoodsStatus(-1)"
                                        >删除</el-button>
                                    </template>
                                    <div v-else style="height: 36px"></div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </el-checkbox-group>
                <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="isSelectAll"
                    class="all"
                >已选{{ selectedGoods.length }}个商品</el-checkbox>
                <p
                    v-if="goodsList.length === 0 && !isGoodsListLoading"
                    class="tbody-nodata color-333"
                >
                    暂无商品，
                    <span
                        class="href"
                        @click="addGoodsWithGroupInfo(currentActiveGroup.level1, currentActiveGroup.level2 || null)"
                    >去添加</span>
                </p>
                <div slot="image">
                    <DragImage :goodsList="getSelectGoods()"></DragImage>
                </div>
            </drag>
        </div>
        <!-- component -->
        <goods-add-and-edit
            :zIndex="2001"
            @add-group-success="getGoodsGroup"
            ref="GoodsAddAndEdit"
        />
        <delete-goods-dialog ref="deleteGoodsDialog"></delete-goods-dialog>
        <goods-switch-on-off-dialog ref="goodsSwitchOnOffDialog"></goods-switch-on-off-dialog>
    </div>
</template>

<script lang="ts">
import {
    createComponent,
    ref,
    onBeforeMount,
    SetupContext,
    watch,
    onMounted,
    computed,
    onBeforeUnmount,
} from "@vue/composition-api";
import $fetch from "@/api";
import uesGoodsGroup from "./use_goods_group";
import useGoodsList from "./use_goods_list";
import Draggable from "vuedraggable/src/vuedraggable.js";
import GoodsAddAndEdit from "../goods_add_and_edit/goods_add_and_edit.vue";
import { openMessage } from "@/utils/system.tsx";
import DeleteGoodsDialog from "./modules/delete_goods_dialog.vue";
import GoodsSwitchOnOffDialog from "./modules/goods_switch_on_off.vue";
import GroupPopper from "./modules/group_popper.vue";
import Search from "@/components/search/search.vue";
import TableDataCascaderFilter from "@/components/table_data_cascader_filter/table_data_cascader_filter.vue";
import getGroup from "@/assets/ts/group";
import { Drag, Drop } from "vue-drag-drop";
import DragImage from "./modules/drag_image.vue";
import MoreOperate from "@/components/more_operate/more_operate.vue";
import get from "lodash/get";
import getGoodsCommonData from "./goods_data";
import {
    tbodyScroll,
    getDataFromStorage,
    setDataFromStorage,
    toggleDataFromStorage,
    isInStorage,
} from "./goods_utils";

export default createComponent({
    data() {
        return {
            searchStyle: {
                placeholder: "请输入关键词",
                width: "248px",
                height: "36px",
            },
        };
    },
    setup(props, ctx: SetupContext) {
        const {
            noGroupGoodsCount,
            allGoodsCount,
            goodsGroup,
            currentActiveGroup,
            isGroupLoading,
            onLevel2Move,
            getGoodsGroup,
            onLevel1DragEnd,
            onLevel2DragEnd,
            level1Dragenter,
        } = uesGoodsGroup(ctx);
        const {
            keyword,
            goodsList,
            isSearch,
            isGoodsListLoading,
            selectedGoods,
            getGoodsByGroup,
            getGoodsListByKeyword,
            onGoodsMove,
            onGoodsDragEnd,
            isSelectAll,
            isIndeterminate,
            bindListenerWithDom,
            eventTarget,
            page,
            isHasMore,
            isLoading,
            getCurEvent,
            status,
            findNodeByLevel,
        } = useGoodsList(
            {
                onGoodsGroupChange: getGoodsGroup,
            },
            ctx
        );
        const isOnSubmit = ref(false);
        const isShowMoreOperate = ref(false);
        const isShowDownGoods = ref(
            localStorage.getItem("isShowDownGoods") != null
                ? JSON.parse(localStorage.getItem("isShowDownGoods") as string)
                : true
        );
        const cascaderVal = ref([]);

        const store = ctx.root.$store;
        const unbindBeforeUnload = () => {
            window.onbeforeunload = null;
        };
        const bindBeforeUnload = () => {
            window.onbeforeunload = setSessionData;
        };

        onBeforeUnmount(() => {
            setSessionData();
            unbindBeforeUnload();
        });

        onBeforeMount(() => {
            let limit = 20;
            isGoodsListLoading.value = true;
            getSessionData();
            bindBeforeUnload();
            if (isInStorage("GOODS_PAGE")) {
                page.value = getDataFromStorage("GOODS_PAGE");
                keyword.value = ''
                isSearch.value = false
                limit = page.value * limit;
            }
            getGoodsByGroup(1, limit).then(() => {
                isGoodsListLoading.value = false;
                tbodyScroll(getDataFromStorage("GOODS_CUR_EVENT"), ctx);
            });
        });

        onMounted(() => {
            bindListenerWithDom(ctx.refs.tbody as any);
        });

        // const selectedGoodsNum = computed(() => {
        //     if (isSelectAll.value) {
        //         if (currentActiveGroup.level1 === 0) {
        //             return allGoodsCount.value
        //         } else if (currentActiveGroup.level1 === -1) {
        //             return noGroupGoodsCount.value
        //         } else {
        //             const curGroup = goodsGroup.value.find(g => g.id === currentActiveGroup.level1)
        //             if (curGroup != null) {
        //                 if (currentActiveGroup.level2 != null && currentActiveGroup.level2 != 0) {
        //                     const curSecGroup = curGroup.secondary_group.find(g => g.id === currentActiveGroup.level2)
        //                     return (curSecGroup != null && curSecGroup.goods_num) || 0
        //                 } else {
        //                     return curGroup.goods_num
        //                 }
        //             } else {
        //                 return 0
        //             }
        //         }
        //     } else {
        //         return selectedGoods.value.length
        //     }
        // })

        watch(isShowDownGoods, (newVal) => {
            if (newVal) {
                status.value = undefined;
            } else {
                status.value = 0;
            }
            localStorage.setItem("isShowDownGoods", JSON.stringify(newVal));
        });

        function getSessionData() {
            page.value = getDataFromStorage("GOODS_PAGE") || page.value;
            currentActiveGroup.level1 =
                getDataFromStorage("GOODS_LEVEL1") || currentActiveGroup.level1;
            currentActiveGroup.level2 =
                getDataFromStorage("GOODS_LEVEL2") || currentActiveGroup.level2;
        }

        function setSessionData() {
            setDataFromStorage("GOODS_LEVEL1", currentActiveGroup.level1);
            setDataFromStorage("GOODS_LEVEL2", currentActiveGroup.level2);
            setDataFromStorage("GOODS_PAGE", page.value);
            setDataFromStorage("GOODS_CUR_EVENT", getCurEvent());
        }

        function switchChange() {
            openMessage("success", "操作成功");
            ctx.root.$nextTick(() => {
                recordPositionAndFetch();
            });
        }

        function changeCascaderVal(level1Obj, level2Obj) {
            if (level1Obj.id === 0 && cascaderVal.value[0] === 0) {
                return;
            }
            if (level1Obj.id !== cascaderVal.value[0]) {
                (cascaderVal.value[0] as any) = level1Obj.id;
                if (level2Obj.id !== 0) {
                    (cascaderVal.value[1] as any) = level2Obj.id;
                }
            }
        }

        function activeLevel(level1Obj: any, level2Obj: any = {}) {
            if (level2Obj.id === 0) {
                level1Obj.isExpand = !level1Obj.isExpand;
            }
            if (
                level2Obj.id &&
                level2Obj.id !== 0 &&
                level1Obj.isExpand === false
            ) {
                level1Obj.isExpand = true;
            }
            // console.log(currentActiveGroup, level1Obj, level2Obj)
            if (
                currentActiveGroup.level1 === level1Obj.id &&
                currentActiveGroup.level2 === level2Obj.id
            ) {
                return;
            }
            currentActiveGroup.level1 = level1Obj.id;
            currentActiveGroup.level2 = level2Obj.id;
            selectedGoods.value = [];
            goodsList.value = [];
            page.value = 1;
            isGoodsListLoading.value = true;
            changeCascaderVal(level1Obj, level2Obj);
            getGoodsByGroup(
                undefined,
                undefined,
                level1Obj.id,
                level2Obj.id
            ).then(() => (isGoodsListLoading.value = false));
        }

        function setGoodsStatus(status) {
            if (selectedGoods.value.length === 0) {
                return openMessage("info", "请勾选商品");
            }
            if (status === -1 && !store.getters["shop/canIUse"](10)) {
                return openMessage("error", "暂无删除商品权限，请联系超管开启");
            }
            if (!store.getters["shop/canIUse"](11)) {
                if (status === 0) {
                    return openMessage(
                        "error",
                        "暂无上架商品权限，请联系超管开启"
                    );
                }
                if (status === 1) {
                    return openMessage(
                        "error",
                        "暂无下架商品权限，请联系超管开启"
                    );
                }
            }
            const params: {
                goods_ids: number[];
                goods_name?: string;
                goods_num?: number;
            } = {
                goods_ids: selectedGoods.value,
            };
            // if (isSelectAll.value) {
            //     params = {
            //         group_id: currentActiveGroup.level1,
            //         secondary_group_id: currentActiveGroup.level2 || undefined
            //     }
            // } else {
            //     params = {
            //         goods_ids: selectedGoods.value
            //     }
            // }
            params.goods_num = selectedGoods.value.length;
            if (params.goods_ids.length === 1) {
                const goodsInfo = goodsList.value.find(
                    (goods) => goods.id === params.goods_ids[0]
                );
                if (goodsInfo != null) {
                    params.goods_name = goodsInfo.name;
                }
            }
            if (status === -1) {
                (ctx.refs.deleteGoodsDialog as any).open({
                    ...params,
                    callback: () => {
                        selectedGoods.value = [];
                        page.value = 1;
                        getGoodsByGroup(
                            undefined,
                            undefined,
                            currentActiveGroup.level1,
                            currentActiveGroup.level2,
                            keyword.value,
                            true
                        );
                        getGoodsGroup();
                    },
                });
            } else {
                (ctx.refs.goodsSwitchOnOffDialog as any).open({
                    ...params,
                    mode: status === 1 ? "off" : "on",
                    callback: () => {
                        selectedGoods.value = [];
                        page.value = 1;
                        getGoodsByGroup(
                            undefined,
                            undefined,
                            currentActiveGroup.level1,
                            currentActiveGroup.level2,
                            keyword.value,
                            true
                        );
                    },
                });
            }
        }

        function showDetail(goods: any) {
            ctx.root.$router.push({
                path: "/main/goodsLibrary/goodsDetail",
                query: {
                    id: goods.id,
                },
            });
        }

        function editDetail(goods: any) {
            (ctx.refs.GoodsAddAndEdit as any).open({
                mode: "update",
                goodsId: goods.id,
                callback: () => {
                    recordPositionAndFetch();
                    getGoodsGroup();
                },
            });
        }

        function recordPositionAndFetch() {
            const curEvent = getCurEvent();
            const limit = page.value * 20;
            setDataFromStorage("GOODS_CUR_EVENT", curEvent);
            goodsList.value = [];
            getGoodsByGroup(
                1,
                limit,
                currentActiveGroup.level1,
                currentActiveGroup.level2,
                keyword.value,
                true
            ).then(() => tbodyScroll(curEvent, ctx));
        }

        function addGoodsWithGroupInfo(level1: string, level2: string) {
            if (!ctx.root.$store.getters["shop/canIUse"](10)) {
                return openMessage("error", "暂无添加商品权限，请联系超管开启");
            }
            (ctx.refs.GoodsAddAndEdit as any).open({
                mode: "create",
                groupId: level1,
                secondaryGroupId: level2,
                callback: () => {
                    const curEvent = getCurEvent();
                    const limit = page.value * 20;
                    goodsList.value = [];
                    getGoodsByGroup(
                        1,
                        limit,
                        currentActiveGroup.level1,
                        currentActiveGroup.level2,
                        keyword.value,
                        true
                    ).then(() => tbodyScroll(curEvent, ctx));
                    getGoodsGroup();
                },
            });
        }

        function searchGoods(keywordStr) {
            // currentActiveGroup.level1 = 0
            // if (type === 'all') {
            //     getGoodsByGroup(0).then(() => isSearch.value = false)
            // } else {
            //     getGoodsListByKeyword(keyword).then(() => isSearch.value = true)
            // }
            page.value = 1;
            getGoodsByGroup(
                undefined,
                undefined,
                currentActiveGroup.level1,
                currentActiveGroup.level2,
                keywordStr,
                true
            );
        }

        function getGoodsGroupName(goods) {
            if (!goods.group) {
                return "";
            }
            let str = goods.group.name;
            if (goods.secondary_group.name) {
                str += "/" + goods.secondary_group.name;
            }
            return str;
        }

        function filterCascaderChange(val) {
            const len = val.length;
            const curGroup = goodsGroup.value.find((g) => {
                if (g.id === val[0]) {
                    if (len === 1) {
                        return true;
                    }
                    if (len === 2) {
                        return g.secondary_group.find((sg) => {
                            return sg.id === val[1];
                        });
                    }
                }
                return false;
            });
            if (curGroup != null) {
                const level2Obj = {
                    id: val[1] || 0,
                };
                activeLevel(curGroup, level2Obj);
            } else {
                activeLevel({ id: val[0] }, { id: 0 });
            }
        }

        function groupChange(type: "add" | "edit" | "delete", isMe: boolean) {
            const isAllGroup = currentActiveGroup.level1 === 0;
            getGoodsGroup().then(() => {
                if (
                    (type === "delete" && isMe) ||
                    (type !== "add" && isAllGroup)
                ) {
                    currentActiveGroup.level1 = 0;
                    currentActiveGroup.level2 = 0;
                }
            });
            if ((type === "delete" && isMe) || (type !== "add" && isAllGroup)) {
                const curEvent = getCurEvent();
                let oPage = page.value,
                    limit = 20;
                if (isAllGroup) {
                    oPage = 1;
                    limit = page.value * limit;
                } else {
                    oPage = page.value = 1;
                }
                activeLevel({ id: 0 }, { id: 0 });
                getGoodsByGroup(
                    oPage,
                    limit,
                    currentActiveGroup.level1,
                    currentActiveGroup.level2,
                    keyword.value,
                    true
                ).then(() => tbodyScroll(curEvent, ctx));
            }
        }

        function getSelectGoods() {
            return goodsList.value.filter((value) => {
                return selectedGoods.value.includes(value.id);
            });
        }

        function onDragEnter(goodsInfo, evt) {
            if (goodsInfo == null || goodsInfo.length === 0) {
                return;
            }
            if (evt && evt.target) {
                ctx.root.$nextTick(() => {
                    const target = findNodeByLevel(evt.target);
                    if (target) {
                        if (
                            target.classList.contains("level-2") ||
                            target.nextElementSibling == null ||
                            (target.nextElementSibling &&
                                target.nextElementSibling.childElementCount < 2)
                        ) {
                            target.style.border = "1px solid #ee5b5b";
                        }
                    }
                });
            }
        }

        function onDragLeave(goodsInfo, evt) {
            console.log("leave");
            if (goodsInfo == null) {
                return;
            }
            if (evt && evt.target) {
                const target = findNodeByLevel(evt.target);
                if (target) {
                    target.style.border = "";
                }
            }
        }

        return {
            // selectedGoodsNum,
            keyword,
            allGoodsCount,
            isGoodsListLoading,
            isGroupLoading,
            isOnSubmit,
            isSearch,
            isShowMoreOperate,
            isShowDownGoods,
            goodsGroup,
            get,
            getGoodsGroup,
            onLevel1DragEnd,
            onLevel2DragEnd,
            goodsList,
            currentActiveGroup,
            activeLevel,
            onGoodsMove,
            onLevel2Move,
            onGoodsDragEnd,
            selectedGoods,
            isSelectAll,
            isIndeterminate,
            setGoodsStatus,
            showDetail,
            editDetail,
            addGoodsWithGroupInfo,
            searchGoods,
            getGoodsGroupName,
            getGroup,
            filterCascaderChange,
            cascaderVal,
            groupChange,
            isHasMore,
            isLoading,
            switchChange,
            getSelectGoods,
            onDragEnter,
            onDragLeave,
            level1Dragenter,
        };
    },
    components: {
        Drag,
        Drop,
        DragImage,
        Search,
        GroupPopper,
        Draggable,
        GoodsAddAndEdit,
        DeleteGoodsDialog,
        GoodsSwitchOnOffDialog,
        TableDataCascaderFilter,
        MoreOperate,
    },
});
</script>

<style lang="scss" scoped>
.operate-detail-item {
    color: #333;
    height: 36px;
    padding: 0 8px;

    &:hover {
        background: #f7f7f7;
    }

    span {
        flex: none;
    }
}

.top-tool {
    position: absolute;
    top: -54px;
    right: 0px;
    color: #666;
}

.goods-list-container {
    margin-top: 12px;
    height: 100%;
    overflow: hidden;
    border: 1px solid #f2f2f2;

    // 左侧商品分组代码开始 -----------------------------------
    .left-grouop {
        float: left;
        height: 100%;
        width: 170px;
        border-right: 1px solid #f2f2f2;
        overflow-y: auto;

        .gourp {
            border-bottom: 1px solid #f2f2f2;
            cursor: pointer;
            background: #fff;

            .level-item {
                background: #fff;
                box-sizing: content-box;
                user-select: none;

                .group-popper {
                    display: none;
                    width: 24px;
                }

                &:hover {
                    background-color: #f5f7fa;

                    .group-popper {
                        display: block;
                    }

                    .goods-count {
                        display: none;
                    }
                }
            }

            .icongengduoda {
                // display: none;
                color: #888888;
                margin-right: 12px;
                font-size: 14px;
            }

            .level-1 {
                position: relative;
                display: flex;
                align-items: center;
                padding: 9px 0;
                padding-left: 30px;
                min-height: 38px;
                color: #333333;

                .iconright {
                    position: absolute;
                    left: 8px;
                    font-size: 14px;
                    color: #999;
                    transition: 0.2s transform;
                }

                .is-rotate {
                    transform: rotate(90deg);
                }
            }

            .gourp-name {
                flex: 1;
                font-size: 14px;
                line-height: 20px;
            }

            .goods-count {
                padding-right: 12px;
                width: 34px;
                text-align: right;
                font-size: 12px;
                color: #999999;
            }

            .level-2-group {
                overflow: hidden;

                .level-2 {
                    display: flex;
                    align-items: center;
                    padding: 9px 0;
                    min-height: 38px;
                    padding-left: 44px;
                    color: #333333;
                }
            }
        }

        .level-active {
            background: rgba(0, 150, 136, 0.1) !important;
            font-size: 14px;
            color: #009688 !important;
        }
    }
    // 左侧导航代码结束 -----------------------------------

    .right-list {
        position: relative;
        height: 100%;
        overflow: hidden;

        .tbody-nodata {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translateX(-50%);
            font-size: 14px;
            color: #909399;
        }

        // 表格样式代码开始 --------------------------------------------------
        table {
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;

            .t-r {
                text-align: right;
            }

            .t-l {
                text-align: left;
            }

            .t-c {
                text-align: center;
            }

            tr {
                display: table;
                width: 100%;
                table-layout: fixed;
                border-top: 1px solid #ebebeb;
                border-bottom: 1px solid #ebebeb;

                &:nth-of-type(1) {
                    border-top: none;
                }

                td:nth-of-type(2) {
                    color: #333;
                }

                &.is-down {
                    color: #999;
                }
            }

            // 单元格宽度定义开始 ----------------------------------
            @mixin tableCellWidth {
                &.all-group {
                    width: 200px;
                    text-align: right;
                }

                &:nth-of-type(1) {
                    width: 20px;
                }

                &:nth-of-type(2) {
                    width: 36px;
                }

                &:nth-of-type(3) {
                    // width: 200px;
                }

                &:nth-of-type(4) {
                }

                &:nth-of-type(5) {
                    width: 140px;
                }

                &:nth-of-type(6) {
                    width: 20px;
                }

                &:nth-of-type(7) {
                    width: 180px;
                }

                &:nth-of-type(8) {
                    width: 140px;
                }

                // &:nth-of-type(9) {
                //     width: 0px;
                // }
            }
            // 单元格宽度定义结束 ----------------------------------

            thead {
                font-weight: bold;
                font-size: 14px;

                td {
                    @include tableCellWidth;
                }

                td {
                    padding: 12px;
                    line-height: 20px;
                    color: #999999 !important;
                }
            }

            tbody {
                flex: 1;
                display: block;
                table-layout: fixed;
                overflow-y: auto;
                height: 100%;
                width: 100%;

                tr {
                    height: 44px;
                    line-height: 44px;
                    border-bottom: none;
                    font-size: 14px;
                    color: #333333;
                    background: #fff;

                    &:hover {
                        background-color: #f5f7fa;
                    }

                    // ::v-deep & > div {
                    //     display: none;
                    // }
                }

                td {
                    @include tableCellWidth;
                }

                td {
                    box-sizing: border-box;
                    padding: 0 12px;
                    vertical-align: middle;

                    ::v-deep .el-checkbox__label {
                        display: none;
                    }
                }
            }

            tfoot {
                // display: block;
                // height: 44px;
                border-top: 1px solid #ebebeb;

                tr {
                    border: none;
                }

                td {
                    padding: 7px 12px;
                    padding-left: 146px;
                }
            }
        }
        // 表格样式代码结束 --------------------------------------------------

        // 全选选择框
        .all {
            position: absolute;
            bottom: 12px;
            left: 12px;
        }
    }
}
</style>
